@use '@material/theme' with (
  $primary: #fff
);

@use '@material/typography' with (
  $font-family: unquote('Chivo, Roboto, sans-serif'),
  $styles-subtitle1: (
    text-transform: uppercase,
    font-size: 14px,
    font-style: 0.875rem,
    font-weight: bold,
    line-height: 1.75,
    letter-spacing: 0.4px,
  )
);

@use '@material/list/mdc-list';
@use '@material/menu-surface/mdc-menu-surface';
@use '@material/menu/mdc-menu';
@use '@material/select/styles';

@import url('https://fonts.googleapis.com/css2?family=Chivo:wght@400;700&display=swap');

:host {
  display: block;
  font-family: 'Chivo', sans-serif;
  font-weight: 400;
}

.mdc-center-image {
  margin: 8px auto;
  text-align: center;
}

.mdc-select {
  .mdc-select__anchor {
    border-radius: 28px;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
    min-width: 156px;
    min-height: 36px;
    width: 100%;
    height: 36px;
  }

  .mdc-select__selected-text {
    font-size: 0.975rem;
    position: relative;
  }

  .mdc-floating-label,
  .mdc-select__selected-text {
    text-align: center;
  }

  .mdc-select__dropdown-icon {
    justify-content: left;
  }

  .mdc-deprecated-list-item {
    font-weight: normal;
  }

  nk-loading {
    position: absolute;
    top: 0;
    left: calc(50% - 12px);
  }
}

.mdc-select:not(.mdc-select--disabled) {
  .mdc-select__anchor {
    background-color: #000;
  }

  .mdc-floating-label,
  .mdc-select__selected-text {
    color: #fff;
  }

  .mdc-select__dropdown-icon {
    fill: #fff;
  }
}

.mdc-select--disabled {
  .mdc-select__anchor {
    background-color: rgba(0, 0, 0, 0.12) !important;
    box-shadow: none;
  }

  .mdc-floating-label,
  .mdc-select__selected-text {
    color: rgba(0, 0, 0, 0.38);
  }

  .mdc-select__dropdown-icon {
    fill: rgba(0, 0, 0, 0.38);
  }
}

.mdc-menu-surface,
.mdc-select--filled .mdc-menu-surface--is-open-below {
  border-radius: 16px;
  box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.1);
}

.mdc-select__menu
  .mdc-deprecated-list
  .mdc-deprecated-list-item.mdc-deprecated-list-item--selected
  .mdc-deprecated-list-item__ripple::before,
.mdc-select__menu
  .mdc-deprecated-list
  .mdc-deprecated-list-item.mdc-deprecated-list-item--selected
  .mdc-deprecated-list-item__ripple::after {
  background-color: rgba(0, 0, 0, 0.2);
}

.mdc-deprecated-list-item
  :not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item
  .mdc-deprecated-list-item__ripple::before,
.mdc-deprecated-list-item
  :not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item
  .mdc-deprecated-list-item__ripple::after {
  background-color: rgba(0, 0, 0, 0.4);
}
